export default "__VITE_ASSET__375302fc__"